<template>
  <v-navigation-drawer
    v-model="internalValue"
    app
    width="260"
    elevation="2"
    :class="isDark ? 'color-bDrawDark' : 'color-bDraw'"
  >
    <!-- ENCABEZADO -->
    <v-sheet :class="isDark ? 'color-bDrawDark' : 'color-bDraw'" class="pa-4">
      <v-img
        :src="require('@/assets/prometheus-light.png')"
        contain
        class="mx-auto mb-2"
        style="width: 100%; max-width: clamp(90px, 60%, 160px)"
      ></v-img>
      <div class="text-h6 font-weight-bold">
        <span style="font-size: 20px">{{ $t("saludo") }}</span> <br />
        <span style="font-size: 16px">{{ nombre }}</span>
      </div>
    </v-sheet>

    <!-- SEPARADOR -->
    <div class="linea-separadora"></div>

    <!-- LISTA DE ENLACES -->
    <v-list nav density="compact" class="side-nav">
      <!-- INICIO (oculto para tester) -->
      <v-list-item
        v-if="!isTester"
        :to="{ name: 'HomePag' }"
        class="nav-item"
        link
      >
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-home" />
          </div>
        </template>
        <v-list-item-title>{{ $t("inicio") }}</v-list-item-title>
      </v-list-item>

      <v-list-item :to="{ name: 'MisUsos' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-chart-donut" />
          </div>
        </template>
        <v-list-item-title> Mi Consumo </v-list-item-title>
      </v-list-item>
      <!-- IAModels 

      <v-list-item :to="{ name: 'IAModel' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-robot" />
          </div>
        </template>
        <v-list-item-title>IAModels</v-list-item-title>
      </v-list-item>-->

      <!-- ChatGPT (oculto para tester) -->

      <v-list-item
        v-if="!isTester"
        :to="{ name: 'ChatGPT' }"
        class="nav-item"
        link
      >
        <template #prepend>
          <div class="nav-icon">
            <v-img
              :src="isDark ? chatgptIcon2 : chatgptIcon"
              class="chatgpt-icon"
              contain
            />
          </div>
        </template>
        <v-list-item-title>ChatGPT</v-list-item-title>
      </v-list-item>

      <!-- IAModels ITW -->
      <v-list-item :to="{ name: 'GeneracionProyecto' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-robot" />
          </div>
        </template>
        <v-list-item-title>IAModels ITW</v-list-item-title>
      </v-list-item>


      <!-- Equipos ITW -->
      <!-- <v-list-item :to="{ name: 'EquiposProyecto' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-account-group" />
          </div>
        </template>
        <v-list-item-title>{{ $t("Equipos") }}</v-list-item-title>
      </v-list-item> -->

      <!-- Grupo -->
      <!-- <v-list-group class="nav-group">
        <template #activator="{ props }">
          <v-list-item v-bind="props" class="nav-item">
            <template #prepend>
              <div class="nav-icon">
                <v-icon icon="mdi-account" />
              </div>
            </template>
            <v-list-item-title>{{ $t("search") }}</v-list-item-title>
          </v-list-item>
        </template>
        <v-list-item class="nav-subitem" link>
          <v-list-item-title>{{ $t("search1") }}</v-list-item-title>
        </v-list-item>
        <v-list-item class="nav-subitem" link>
          <v-list-item-title>{{ $t("search2") }}</v-list-item-title>
        </v-list-item>
      </v-list-group> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import "@/css/DashNavigator/StyleDashNavigator.css";
import chatgptIcon from "@/assets/chatgpt.png";
import chatgptIcon2 from "@/assets/chatgpt2.png";
import { useSettingsStore } from "@/stores/settings";
import { useAuthStore } from "@/stores/auth";

export default {
  name: "DashNavigator",
  inject: ["vuetify"],
  data() {
    return {
      chatgptIcon,
      chatgptIcon2,
    };
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    nombre: {
      type: String,
      required: true,
    },
  },

  //modelValue'], // evento que voy a emitir desde mi propiedad personalizada
  computed: {
    isDark() {
      const settings = useSettingsStore();
      return settings.theme === "dark";
    },
    // Tester QA: el menú se limita a "Mi Uso" e "IAModels ITW".
    // Rol reactivo desde el store (fuente = backend).
    isTester() {
      return useAuthStore().isTester;
    },
    //Propiedades computadas
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        // este es el valor de la propiedad False o True
        //console.log("computada ", val);
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>
